import React, { useEffect, useState} from "react";
import Header from '../components/Header';
import { Link } from "react-router-dom";
import Nodata from "../components/NoData";
import Accordion from 'react-bootstrap/Accordion';
import { BsFillPenFill, BsFillTrashFill } from "react-icons/bs";
import {alert, confirm} from "../components/MegConfirmAlert";
import { useTranslation } from 'react-i18next';
import { useAxios } from "../services/useAxios";
import Modal from 'react-bootstrap/Modal';
import InquiryOooWrite from "./InquiryOooWrite"

export default function InquiryOoo (){
    const userInfo = JSON.parse(localStorage.getItem("user")).data;
    const { t } = useTranslation();
    const [data, setData] = useState({});
    const [dataList, setDataList] = useState([]);
    const [page, setPage] = useState(0);
    const [request] = useAxios();
    const [replyList, setReplyist] = useState([]);
    const [isQnAOpen, setQnaOpen] = useState(false);

  

    const fetchData3 = async (obj) => {
        
        
        const response = await request.post("/app/mypage/getInqryNttReplyListAPI", {                
            firstNttSn : obj.nttSn,
            bbsSn : 2
            });
        if(response.data.resultCode === 200){         
            console.log(response.data.result)        
            setReplyist((prevData) => [...prevData, ...response.data.result.goodsInqryReplyList]);
        }     
           
        
    }
    const fn_delNtt = async (obj) => {
        const result = await confirm(t(`Message.inqry_info_page_remove_confirm`), {okText : t(`Message.common_yes`) , cancelText :t(`Message.common_no`)});
        if(result){
            const response = await request.post("/app/mypage/procInqryNttRemoveAPI", {                
                nttSn : obj.nttSn,
                bbsSn : 2
                });
            if(response.data.resultCode === 200){  
                await alert(t(`Message.common_msg_deleted`), {okButtonStyle : 'secondary', okText: t(`Message.common_ok`)});        
                window.location.reload();              
            }else{
                alert(response.data.resultMessage)
            }
        }
    }
    

    const fetchData = async (pageIndex) => {
        
        const response = await request.post("/app/mypage/getInqryNttListAPI", {            
            bbsSn : 2,    
            replyShowAt : 'Y',
            writerDplctCode : userInfo.userId,
            aditfield5 : 'INQ002',
            pageIndex : pageIndex

        });
        if(response.data.resultCode === 200){     
                  
            setDataList((prevData) => [...prevData, ...response.data.result.resultList]);      
            response.data.result.resultList.forEach(function (value, index) {
                fetchData3(value)
            })      
        }            
    };

    useEffect(() => {    
        if(page > 0){
            fetchData(page);    
        }
      }, [page]);


    const handleObserver = (entries) => {
        const target = entries[0];
        if (target.isIntersecting ) {
            setPage((prevPage) => prevPage + 1);
        }
      };
    
      useEffect(() => {
        const observer = new IntersectionObserver(handleObserver, {
          threshold: 0, //  Intersection Observer의 옵션, 0일 때는 교차점이 한 번만 발생해도 실행, 1은 모든 영역이 교차해야 콜백 함수가 실행.
        });
        // 최하단 요소를 관찰 대상으로 지정함
        const observerTarget = document.getElementById("observer");
        // 관찰 시작
        if (observerTarget) {
          observer.observe(observerTarget);
        }
      }, []);

    return (
        <div>
            <div className="backGround bgBlue"></div>
            <div className="headFixed backGround bgBlue">
                <Header type="cart" pageTitle={t(`Message.inqry_info_page_tab1`)}/>
                <div className="tabArea">
                    <Link to="/Inquiry" className="tabBtn active">{t(`Message.inqry_info_page_tab1`)}</Link>
                    <Link to="/InquiryProduct" className="tabBtn">{t(`Message.inqry_info_page_tab2`)}</Link>
                    <Link to="/InquiryBulk" className="tabBtn">{t(`Message.inqry_info_page_tab3`)}</Link>
                </div>
            </div>

            <div className="hdTabContWr">
            {dataList && dataList.length === 0?(
                 <div className="floatCenter">
                    <Nodata text={t(`Message.private_inqry_list_empty`)}/>
                </div>  
             ):(
    
                <div className="pb60">
                    <Accordion className="prodQnaAccordion">
                    {dataList && dataList.map((obj, index) => (
                        <Accordion.Item eventKey={index} key={index}>
                            <Accordion.Header>
                                <div className="inqHd">
                                    <ul className="dfsb">
                                        <li className="dfcsG12">
                                        <p className={"qnaTag "+(obj.replyCnt > 0?"fin":"wait")}>{obj.replyCnt > 0? t(`Message.goods_inqry_list_answer_complate`):t(`Message.goods_inqry_list_answer_wait`)}</p>
                                            <p className="date">{obj.frstRegistPnttm}</p>
                                        </li>
                                        {obj.replyCnt <= 0?(
                                        <li className="dfceG6">
                                            <>
                                            <div 
                                                className="btn2424 pen"
                                                onClick={(e) => {
                                                    e.preventDefault(); 
                                                    e.stopPropagation(); 
                                                    setData(obj)
                                                    setQnaOpen(true)
                                                }}
                                            >
                                                <BsFillPenFill />
                                            </div>
                                          
                                            <div
                                                className="btn2424 del"
                                                onClick={(e) => {
                                                    e.preventDefault(); 
                                                    e.stopPropagation();
                                                    fn_delNtt(obj)
                                                   
                                                }}
                                            >
                                                <BsFillTrashFill />
                                            </div>
                                            </>
                                        </li>
                                        ):null}
                                    </ul>
                                    <p className="qnaTit">{obj.nttSj}</p>
                                </div>
                            </Accordion.Header>
                            <Accordion.Body>
                                <div className="qnaCont pd0">{obj.nttCn}</div>
                                {replyList && replyList.filter((el) => el.firstNttSn === obj.nttSn).map((obj2, index2) => (
                                <div className="answerWr" key={index2}>
                                    <p className="greenTxt">A.</p>
                                    <p className="answer">{obj2.nttCn}</p>
                                </div>
                                ))}  
                            </Accordion.Body>
                        </Accordion.Item>
                         ))}  
                        
                    </Accordion>
                </div>
                )}
                <div id="observer" style={{ height: "10px" }}></div>                                    

                <button type="button" className="floatBtn" onClick={(e) => {setData({}); setQnaOpen(true)}}>{t(`Message.private_inqry_list_reg_btn`)}</button>
            </div>
            <Modal
                className="btModal"
                show={isQnAOpen}
                onHide={setQnaOpen}
                fullscreen={true}
                aria-labelledby="contained-modal-title-vcenter"
                centered                
                keyboard={false}
                >
                <InquiryOooWrite modal={true} closeFn={setQnaOpen} dataInfo={data} ></InquiryOooWrite>
            </Modal>
        </div>
    );
}